import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const items = [
  "USCIS Applications",
  "NVC Support",
  "Consular Processing",
  "Citizenship",
  "Family Petitions",
  "Certified Translations",
];

export const EditorialMarquee = () => (
  <div className="overflow-hidden border-y border-brand-navy/10 bg-brand-cream py-5" data-testid="editorial-services-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item) => (
        <div key={item} className="mx-10 flex items-center gap-10 whitespace-nowrap">
          <span className="overline text-brand-navy/80">{item}</span>
          <Asterisk className="h-4 w-4 text-brand-copper" aria-hidden="true" />
        </div>
      ))}
    </Marquee>
  </div>
);
